import { Link } from "react-router-dom";
import Icon from "@/components/ui/Icon";

const serviceLinks = [
  { label: "Kasetli Tente İzmir", href: "/hizmetler/kasetli-tente-izmir" },
  { label: "Körüklü Tente İzmir", href: "/hizmetler/koruklu-tente-izmir" },
  { label: "Mafsallı Tente İzmir", href: "/hizmetler/mafsalli-tente-izmir" },
  { label: "Bioklimatik Pergola İzmir", href: "/hizmetler/bioklimatik-pergola-izmir" },
  { label: "Otomatik Pergola İzmir", href: "/hizmetler/otomatik-pergola-izmir" },
  { label: "Zip Perde İzmir", href: "/hizmetler/zip-perde-izmir" },
  { label: "Şeffaf Branda İzmir", href: "/hizmetler/seffaf-branda-izmir" },
];

const pageLinks = [
  { label: "Ana Sayfa", href: "/" },
  { label: "Hakkımızda", href: "/hakkimizda" },
  { label: "Hizmetler", href: "/hizmetler" },
  { label: "Referanslar", href: "/referanslar" },
  { label: "SSS", href: "/sss" },
  { label: "İletişim", href: "/iletisim" },
];

export default function Footer() {
  return (
    <footer className="bg-[#f7f4ef] border-t border-[#e8e0d0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-5">
              <span className="text-xl md:text-2xl font-extrabold tracking-tight leading-none text-stone-900">İzmir <span style={{ color: '#C9A34D' }}>Tenteci</span></span>
            </div>
            <p className="text-stone-500 text-sm leading-relaxed mb-6">
              İzmir'in güvenilir tente, pergola ve branda uzmanı. Kaliteli malzeme, uzman montaj, uygun fiyat.
            </p>
            <div className="flex flex-col gap-3">
              <a href="tel:+905362771709" className="flex items-center gap-3 group cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1a3d2b]/10 text-[#1a3d2b] group-hover:bg-[#1a3d2b] group-hover:text-[#a8d5b5] transition-all">
                  <Icon name="ri-phone-line" className="text-sm" />
                </div>
                <span className="text-stone-700 text-sm font-medium group-hover:text-[#1a3d2b] transition-colors">0536 277 17 09</span>
              </a>
              <a href="https://wa.me/905362771709" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-3 group cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-green-100 text-green-700 group-hover:bg-green-600 group-hover:text-white transition-all">
                  <Icon name="ri-whatsapp-line" className="text-sm" />
                </div>
                <span className="text-stone-700 text-sm font-medium group-hover:text-green-700 transition-colors">0536 277 17 09</span>
              </a>
              <a href="mailto:atatente@hotmail.com" className="flex items-center gap-3 group cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1a3d2b]/10 text-[#1a3d2b] group-hover:bg-[#1a3d2b] group-hover:text-[#a8d5b5] transition-all">
                  <Icon name="ri-mail-line" className="text-sm" />
                </div>
                <span className="text-stone-700 text-sm font-medium group-hover:text-[#1a3d2b] transition-colors">atatente@hotmail.com</span>
              </a>
            </div>
          </div>

          {/* Pages */}
          <div>
            <h4 className="text-[#0d2218] font-bold text-sm mb-5 uppercase tracking-wider">
              <a href="#sayfalar">Sayfalar</a>
            </h4>
            <ul className="space-y-2.5">
              {pageLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-stone-500 text-sm hover:text-[#1a3d2b] transition-colors flex items-center gap-2 group">
                    <Icon name="ri-arrow-right-s-line" className="text-[#1a3d2b]/30 group-hover:text-[#1a3d2b] transition-colors" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#0d2218] font-bold text-sm mb-5 uppercase tracking-wider">
              <a href="#hizmetler">Hizmetler</a>
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-stone-500 text-sm hover:text-[#1a3d2b] transition-colors flex items-center gap-2 group">
                    <Icon name="ri-arrow-right-s-line" className="text-[#1a3d2b]/30 group-hover:text-[#1a3d2b] transition-colors" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas + CTA */}
          <div>
            <h4 className="text-[#0d2218] font-bold text-sm mb-5 uppercase tracking-wider">
              <a href="#hizmet-bolgeleri">Hizmet Bölgeleri</a>
            </h4>
            <p className="text-stone-500 text-sm leading-relaxed mb-6">
              Karşıyaka, Bornova, Buca, Gaziemir, Balçova, Narlıdere, Çiğli, Bayraklı, Konak, Menemen, Torbalı, Urla, Seferihisar, Güzelbahçe, Menderes ve tüm İzmir.
            </p>
            <a
              href="tel:+905362771709"
              className="inline-flex items-center gap-2 bg-[#1a3d2b] hover:bg-[#14301f] text-[#a8d5b5] text-sm font-bold px-5 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              <Icon name="ri-phone-fill" className="text-sm" />
              Ücretsiz Keşif İçin Ara
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#e8e0d0]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-stone-400">
            © 2026 İzmir Tenteci — İzmir Tente, Pergola ve Branda Sistemleri | Tüm Hakları Saklıdır
          </p>
          <p className="text-xs text-stone-400">izmirtenteci.com</p>
        </div>
      </div>
    </footer>
  );
}
